import styles from './SidePanel.module.css';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import sidePanels from '$components/SidePanel/sidePanels';
import { usePanel } from '$hooks/usePanel';
import { isSmallScreenSelector } from '$redux/config/configSelectors';
import { routeSelector } from '$redux/route/routeSelectors';
export const SIDE_PANEL_ANIMATION_DURATION = 300;

export function SidePanel() {
    const { panel, payload, closePanel } = usePanel();
    const { configRoute } = useSelector(routeSelector);
    const { isSmallScreen } = useSelector(isSmallScreenSelector);
    const Component = panel ? sidePanels[panel].Component : null;

    const headerWrapperElement = document.getElementById('header-wrapper');
    const headerElement = headerWrapperElement?.children.namedItem('header');

    useEffect(() => {
        closePanel();
    }, [configRoute]);

    return (
        <div
            id="panel"
            className={styles.panel}
            style={{
                marginTop: !isSmallScreen ? headerElement?.scrollHeight : undefined,
                height: !isSmallScreen ? `calc(100% - ${headerElement?.scrollHeight}px)` : undefined
            }}
        >
            {Component ? <Component payload={payload} closePanel={closePanel} /> : null}
        </div>
    );
}
